const acceptedPapers = [
  {
    title: "Backtracking Counterfactuals",
    author:
      "Julius Von Kügelgen, Abdirisak Mohamed, Sander Beckers",
  },
];

export default acceptedPapers;
